import { Controller } from '@hotwired/stimulus';

import I18n from '@/modules/i18n';
import TomSelect from 'tom-select';
import { trigger } from '@/modules/helper';

export default class extends Controller {
  connect() {
    const options = {
      create: false,
      onItemAdd: (value, item) => {
        trigger(this.element, 'multi-select:selected', { element: this.element, item, value });
      },
      onItemRemove: (value, item) => {
        trigger(this.element, 'multi-select:selected', { element: this.element, item, value });
      },
      plugins: ['remove_button'],
      render: {
        no_results: (_data, _escape) => `<div class="no-results">${I18n.t('no_result')}</div>`,
      },
    };

    if (this.element.dataset.maxItem) options.maxItems = parseInt(this.element.dataset.maxItem, 10);

    if (!this.element.tomselect) {
      this.tomselect = new TomSelect(this.element, options);

      this.element.tomselect = this.tomselect;
    }

    trigger(this.element, 'multi-select:ready', { element: this.element, tomselect: this.tomselect });
  }
}
